import { TableDto } from "api"
import { jsPDF } from "jspdf"
import "jspdf-autotable"
import autoTable from "jspdf-autotable"
import "./Rubik-Regular-normal"


const isEnglishText = (text: string): boolean => {
  const englishRegex = /[a-zA-Z]/;
  return englishRegex.test(text);
};
const formatTextRTL = (text: any) => {
  if (typeof text === "string") {
    const rtlText = text.split(",").map((word) => isEnglishText(word) ? `${word.trim()}\u200F` : word).join(", ");
    return rtlText;
  }
  return text; // If not a string, return as-is
};

export const generatePDF = (tables: TableDto[]) => {
  const doc = new jsPDF();
  doc.addFont("Rubik-Regular-normal.ttf", "Rubik-Regular", "normal");
  doc.setFont("Rubik-Regular");
  doc.setLanguage("he");
  doc.setR2L(true); // Enable Right-To-Left for Hebrew

  tables.forEach((el) => {
    const tableColumn = el.Header.Columns.reverse(); // Format headers
    const tableRows: string[][] = [];
    el.Rows.forEach((row) => {
      // we use formatTextRTL to inssure the text is read in RTL by the pdf
      const newRow = row.Columns.map((col, index) =>  index === row.Columns.length - 1 ? formatTextRTL(col) : col).reverse(); // Format cells
      tableRows.push(newRow);
    });

    // Add table with autoTable (with RTL support)
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      useCss: true,
      styles: {
        font: "Rubik-Regular",
        halign: "right",
      },
      headStyles: {
        halign: "right",
      },
      columnStyles: {
        0: { halign: "right" },
      },
    });
  });
  // Open the generated PDF in a new tab
  window.open(doc.output("bloburl"), "_blank");
};